import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom'
import {
  Title,
  Spinner,
  DataTable,
  DateFormat,
  HttpService,
  API,
  Common,
  Permissionkeys
} from '../../config/react'
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars'
const Inquiry = () => {
  // const history = useHistory()
  const path = useLocation()
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [ShowFilters, setShowFilters] = useState(false)
  const [totalRows, settotalRows] = useState()
  const [OrderInquiryList, setOrderInquiryList] = useState([])
  const [currentPage, setCurrentPage] = useState(
    path.state ? (parseInt(path.state.state.page) === 0 ? 1 : parseInt(path.state.state.page)) : 1
  )
  console.log(path.state)

  const DefaultFilters = {
    ordernumber: path.state?.state?.ordernumber !== undefined ? path.state.state.ordernumber : '',
    email: path.state?.state?.email !== undefined ? path.state.state.email : '',
    orderfromdate:
      path.state?.state?.orderfromdate !== undefined
        ? new Date(path.state.state.orderfromdate)
        : '',
    ordertodate:
      path.state?.state?.ordertodate !== undefined ? new Date(path.state.state.ordertodate) : '',
    page: currentPage,
    page_size: 10
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const columns = [
    // {
    //     name: 'Id',
    //     selector: row => row.id,
    // },
    {
      name: 'Inquiry Number',
      selector: (row) => row.order_number,
      wrap: true
    },
    {
      name: 'Email',
      selector: (row) => row.email,
      wrap: true
    },
    {
      name: 'Total',
      selector: (row) => row.symbol + row.order_total
    },
    {
      name: 'Item(s)',
      selector: (row) => row.qty
    },
    {
      name: 'Inquiry Date',
      selector: (row) => <DateFormat value={row.order_date}></DateFormat>,
      wrap: true
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={
              '/inquiry/view/inquiry_id/' +
              row.order_number +
              '?page=' +
              CustomFilters.page +
              '&ordernumber=' +
              CustomFilters.ordernumber +
              '&email=' +
              CustomFilters.email +
              '&orderfromdate=' +
              CustomFilters.orderfromdate +
              '&ordertodate=' +
              CustomFilters.ordertodate
            }
            className="text-dark"
            title="View"
          >
            <i
              className="mdi mdi-eye"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]
  useEffect(() => {
    if (!Common.validatePermission(Permissionkeys.Sales)) {
      history.push('/')
    }
    setIsAuth(true)
    setForceUpdate(!isForceUpdate)
    document.title = Title.OrderInquiry
    GetInquiryList()
  }, [CustomFilters])

  const GetInquiryList = () => {
    const param = {
      ordernumber: CustomFilters.ordernumber,
      email: CustomFilters.email,
      orderfromdate: CustomFilters.orderfromdate,
      ordertodate: CustomFilters.ordertodate,
      page: CustomFilters.page,
      page_size: CustomFilters.page_size
    }
    setLoading(true)
    HttpService.postApi(API.GetInquiryAdminLists, param).then((response) => {
      try {
        setLoading(false)
        const data = response.data.result[1]

        setOrderInquiryList(data)
        settotalRows(response.data.result[0][0].total_row)
        setForceUpdate(!isForceUpdate)
      } catch (error) {
        setLoading(false)
        console.log(error)
      }
    })
  }
  const openFilterBox = () => {
    if (ShowFilters) {
      setShowFilters(false)
    } else {
      setShowFilters(true)
    }
  }
  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }
  const handleInputChanges = (e, fieldName) => {
    if (fieldName === 'orderdate') {
      if (e.value !== null) {
        Object.assign(CustomFilters, { orderfromdate: e.value[0] })
        Object.assign(CustomFilters, { ordertodate: e.value[1] })
      } else {
        Object.assign(CustomFilters, { orderfromdate: '' })
        Object.assign(CustomFilters, { ordertodate: '' })
      }
    } else CustomFilters[fieldName] = e.target.value
    setForceUpdate(!isForceUpdate)
  }
  const ClearFilter = () => {
    setCustomFilters(DefaultFilters)
    setForceUpdate(!isForceUpdate)
  }
  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.OrderInquiry} </h3>
        <div className="btn-group ml-auto">
          <Link
            to="#"
            onClick={openFilterBox}
            className="btn btn-primary btn-fw rounded filter-btn mr-2"
          >
            {' '}
            Filters{' '}
          </Link>
        </div>
      </div>
      <div
        className={ShowFilters ? 'filter-bar d-block' : 'filter-bar'}
        id="filter-bar"
      >
        <div className="grid-margin w-100 stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">
                      <strong>Inquiry Number</strong>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={(e) => handleInputChanges(e, 'ordernumber')}
                      value={CustomFilters.ordernumber}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">
                      <strong>Email</strong>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={(e) => handleInputChanges(e, 'email')}
                      value={CustomFilters.email}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">
                      <strong>Inquiry Date</strong>
                    </label>
                    <DateRangePickerComponent
                      onChange={(e) => handleInputChanges(e, 'orderdate')}
                      value={[CustomFilters.orderfromdate, CustomFilters.ordertodate]}
                    ></DateRangePickerComponent>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3 mt-1 pt-3 text-left">
                  <div className="btn-group">
                    <Link
                      to="#"
                      className="btn btn-dark btn-fw-130 rounded mr-2"
                      onClick={(e) => GetInquiryList(e)}
                    >
                      {' '}
                      Apply{' '}
                    </Link>
                  </div>
                  <div className="btn-group ml-auto">
                    {/* <Link to="#" className="btn btn-primary btn-fw rounded mr-2" onClick={e => ClearFilter(e)}> Cancel </Link> */}
                    <span className="filter-result-repeat">
                      <Link>
                        <button
                          className="btn btn-primary btn-fw-130 rounded mr-2"
                          onClick={ClearFilter}
                        >
                          Reset
                        </button>
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="grid-margin w-100 stretch-card">
        <div className="card">
          <div className="card-body">
            {/* <button
              className="btn btn-primary float-right mb-2"
              // onClick={handleExportExcel}
            >
              Export Excel
            </button> */}
            <div className="table-responsive">
              <DataTable
                columns={columns}
                data={OrderInquiryList}
                pagination
                persistTableHead={true}
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                responsive={true}
                progressPending={loading}
                paginationDefaultPage={currentPage}
                progressComponent={<Spinner />}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Inquiry
